import React, { FC, useState, MouseEvent, useEffect } from 'react';
import { Text, Button } from '@grupoboticario/flora-react';
import {
  Wrapper,
  Header,
  StyledExpandIcon,
  StyledBackIcon,
  StyledCloseIcon,
  Content,
} from './MobileDrawer.styles';
import { useStyle } from 'src/contexts/StyleContext';

export const TEST_ID = {
  WRAPPER: 'WRAPPER',
  HEADER: 'HEADER',
  BACK_BTN: 'BACK_BTN',
  TITLE: 'TITLE',
  CLOSE_BTN: 'CLOSE_BTN',
  CONTENT: 'CONTENT',
};

export enum TrackingAction {
  CLOSE = 'fechar',
  OPEN = 'abrir',
}

export interface IMobileDrawerProps {
  closedTitle: string;
  openedTitle: string;
  startOpened?: boolean;
  hasContent?: boolean;
  hasInnerLevel?: boolean;
  handleBackFromInnerLevel?: () => void;
  eventAnalytics?: (action: TrackingAction) => void;
}

export const MobileDrawer: FC<IMobileDrawerProps> = ({
  closedTitle,
  openedTitle,
  startOpened = false,
  hasContent,
  hasInnerLevel,
  handleBackFromInnerLevel,
  eventAnalytics,
  children,
}) => {
  const [isOpened, setIsOpened] = useState(startOpened);

  const { setIsProductDrawerOpen } = useStyle();

  useEffect(() => {
    setIsProductDrawerOpen(isOpened);
  }, [isOpened]);

  const toggleDrawer = () => {
    setIsOpened(!isOpened);
    eventAnalytics &&
      eventAnalytics(isOpened ? TrackingAction.CLOSE : TrackingAction.OPEN);
  };

  const handleBackButton = (e: MouseEvent) => {
    e.stopPropagation();
    handleBackFromInnerLevel && handleBackFromInnerLevel();
  };

  const contentVisibilityAttrs = !isOpened ? { hidden: true } : {};

  if (!hasContent) {
    return null;
  }

  return (
    <Wrapper role="dialog" isOpened={isOpened} data-testid={TEST_ID.WRAPPER}>
      <Header
        onClick={toggleDrawer}
        data-testid={TEST_ID.HEADER}
        center={!isOpened}
      >
        {(!hasInnerLevel || !isOpened) && (
          <StyledExpandIcon isOpened={isOpened} />
        )}

        {hasInnerLevel && isOpened && (
          <Button
            variant="alt"
            rightIcon={<StyledBackIcon />}
            label="Voltar"
            onClick={handleBackButton}
            size="small"
            css={{ padding: '$0', background: 'transparent' }}
            data-testid={TEST_ID.BACK_BTN}
          />
        )}

        <Text
          id="testefocus"
          size="auxiliarSmall"
          align="center"
          data-testid={TEST_ID.TITLE}
        >
          {isOpened ? openedTitle : closedTitle}
        </Text>

        {isOpened && (
          <Button
            variant="alt"
            rightIcon={<StyledCloseIcon />}
            label="Fechar"
            size="small"
            css={{ padding: '$0', background: 'transparent' }}
            data-testid={TEST_ID.CLOSE_BTN}
          />
        )}
      </Header>
      <Content {...contentVisibilityAttrs} data-testid={TEST_ID.CONTENT}>
        {children}
      </Content>
    </Wrapper>
  );
};
